/**
 * RVOL thresholds that BOTH the server and the browser need.
 *
 * 🚨 WHY THIS FILE EXISTS RATHER THAN THE CONSTANT LIVING IN rvolBaseline.ts. It already lived there
 * and was exported — and it was ALSO hand-copied as a bare `const RVOL_MIN_SAMPLES = 10` into
 * src/components/StockLivePulse.tsx and app/chart/[symbol]/page.tsx. That was not carelessness: both
 * are `'use client'` files and rvolBaseline.ts imports `db`, so importing the real constant would drag
 * server code into the bundle. The boundary FORCED the copy.
 *
 * ⛔ SO THE DRIFT WAS BUILT IN. Three copies of the number that decides whether the UI labels an RVOL
 * reading "thin", and editing the exported one would have moved the server's opinion while two user
 * facing surfaces silently kept 10. Nothing would have errored; the chart and the pulse would simply
 * have disagreed with the snapshot about which readings are trustworthy.
 *
 * ⭐ A LEAF MODULE WITH NO IMPORTS IS THE FIX. It can be imported from a client component and a server
 * module alike, so there is one number again. ⚠ Keep it that way: adding ANY import to this file that
 * reaches the database puts the copies back.
 *
 * 📐 THE NUMBER IS NOT ARBITRARY, measured 2026-09-05 over 14 days of rvol_alerts joined to the
 * baseline cell each one actually used:
 *         baseline depth      alerts     pct
 *         >= 10 samples      241,779    88.6%
 *         2-9 samples         23,919     8.8%
 *         no baseline row      4,090     1.5%   (rider/news — they never consult it, mean rvol 0.00)
 *         ONE sample           3,240     1.2%   (mostly ema_trending/rider, also rvol 0.00)
 * ⭐ So 88.6% of alerts already rest on a denominator at or above this bar. Raising it costs coverage
 * on the 8.8% band; lowering it buys almost nothing, because the thin cells are concentrated in
 * symbols and minutes that do not alert.
 */

/** Below this many sampled sessions the denominator is too thin to trust; the UI says so. */
export const RVOL_MIN_SAMPLES = 10
